import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import Text from '../../typography'
import styled from 'styled-components';
import { theme } from '../../../themes/default-theme';
import {Grid, Box} from '@material-ui/core';
import { Cta } from '../../ui';
import Link from 'next/link';
import ReactHtmlParser from 'react-html-parser';

const Wrapper = styled.div`
`

const Container = styled.div`
    text-align: center;
`
const BodyTextContent = styled.div`
    margin: 20px 0;
`
 
const SeriesBodyText = (props) => {

    const {
        background,
        title,
        preTitle,
        content,
        link,
        colourTheme        
    } = props;

    const mainFontColour = (colourTheme === 'light' && background !== 'black') ? 'charcoal' : (colourTheme !== 'light' && background === 'black') ? 'white' : 'white'

    return (
        <>
            <Wrapper>
                <Container background={background}>
                    <Grid container direction={'row'}>
                        <Grid item xs={12}>
                            {preTitle &&
                                <Box px={2}>
                                    <Text variant="subTitle" colour={"vividBlue"} uppercase="true" align="center">{preTitle}</Text>
                                </Box>
                            }
                            {title &&
                                <Box px={2}>
                                    <Text variant="h2" weight={800} colour={mainFontColour} uppercase="true" align="center">{title}</Text>
                                </Box>
                            }
                            {content &&
                                <BodyTextContent>
                                    <Box px={2}>
                                        <Text variant="body1" colour={mainFontColour} align="center">{ReactHtmlParser(content)}</Text>                                
                                    </Box>
                                </BodyTextContent>
                            }
                            {link && link.title &&
                                <Cta inline href={link.href || '#'} target={link.target}>
                                    {link.title}
                                </Cta>
                            }
                        </Grid>
                    </Grid>
                </Container>
            </Wrapper>
        </>
    )
}

SeriesBodyText.propTypes = {
  background: propTypes.string,
  title: propTypes.string,
  preTitle: propTypes.string,
  content: propTypes.string,
  link: propTypes.object,
  colourTheme: propTypes.string
}

SeriesBodyText.defaultProps = {
  background: null,
  title: null,
  preTitle: null,
  content: null,
  link: {},
  colourTheme: 'light'
}

export default SeriesBodyText